import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderCharm from './HeaderCharm';
import strings from 'owa-strings/owa-common-strings';
import { HelpPane } from 'owa-header-pane';
import { observer } from 'mobx-react';
var HelpCharm = /** @class */ (function (_super) {
    tslib_1.__extends(HelpCharm, _super);
    function HelpCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HelpCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { key: "help", icons: { iconName: "Help" /* Help */ }, ariaLabel: strings.helpCharm_ariaLabel, title: strings.helpCharm_ariaLabel, behavior: {
                paneComponent: HelpPane,
                charm: 2 /* HelpCharm */,
            } }));
    };
    HelpCharm = tslib_1.__decorate([
        observer
    ], HelpCharm);
    return HelpCharm;
}(React.Component));
export default HelpCharm;
//# sourceMappingURL=HelpCharm.js.map